import {
  FetchSmtpSettingsRequest,
  FetchSmtpSettingsSuccess,
  FetchSmtpSettingsFailure,
  UpdateSmtpSettingsRequest,
  UpdateSmtpSettingsSuccess,
  UpdateSmtpSettingsFailure,
} from './smtp-settings.actions'
import { SmtpSettingsService } from './smtp-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as SmtpSettingsTypes from './smtp-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class SmtpSettingsEffects {
  constructor(
    private actions: Actions,
    private smtpSettingsService: SmtpSettingsService,
  ) {}

  FetchSmtpSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SmtpSettingsTypes.FETCH_SMTP_SETTINGS_REQUEST),
      switchMap((action: FetchSmtpSettingsRequest) => {
        return this.smtpSettingsService.fetchSmtpSettings().pipe(
          map((result) => {
            return new FetchSmtpSettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchSmtpSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateSmtpSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SmtpSettingsTypes.UPDATE_SMTP_SETTINGS_REQUEST),
      switchMap((action: UpdateSmtpSettingsRequest) => {
        return this.smtpSettingsService.updateSmtpSettings(action.payload).pipe(
          switchMap((result) => {
            return [new UpdateSmtpSettingsSuccess()]
          }),
          catchError((err, caught) => {
            return of(new UpdateSmtpSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
